module.exports = __webpack_public_path__ + "static/media/20ECE21.7a9c36a2.jpg";